import { useEffect, useLayoutEffect, useState, useRef} from "react";
import { connect, useStore } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import useMedia from "use-media";
import commonUtil from "../../common/commonUtil";
import { apiKeyCheck, detailConditionApi, GetGolfPlanDetail, golfReservationCancel, versionGetApi, golfReserveChk } from "../../const";
import common from '../../resources/js/common/common';
import { Button } from "../atoms/button";
import { Label } from '../atoms/label';
import './../../resources/css/reservationConfirm/reservationConfirm.css';
import { GolfFooterContainer } from "./golfFooterContainer";
import { PullDownOptionForm } from "../molecules/pullDownOptionForm";
import '../../resources/css/reserveChk/reserveCheck.css'

const GolfReservationCheckDetailContainer = (props) => {
    const {
        kaiinken,
        setKaiinken,
        setGolfReservationCheck,
        golfReservationCheck
    } = props;

    //レスポンシブ対応
    const isWidePhone = useMedia({ maxWidth: '480px' });
    const isWideTablet = useMedia({ maxWidth: '960px' });
    const [Phone, setPhone] = useState(false);
    const [Tablet, setTablet] = useState(false);
    const useMediaFlag = useMedia({ maxWidth: '480px' });
    const [isMobilePhone, setIsMobilePhone] = useState(false);
    

    const history = useHistory();
    const store = useStore();

    const processing = useRef(false);

    // プロパティ一覧
    const [successFlg, setSuccessFlg] = useState(false);

    useLayoutEffect(() => {
        // リフレッシュ対応
        let state = store.getState().login;
        let apiKey = null;
        if (Object.keys(state).length !== 0) {
            apiKey = state.apiKey;
        }
        if (apiKey === null) {
            store.dispatch({ type: "CLEAR_STATE" });
            history.push("/reserve/login");
        }
        if (apiKey) {
            common.doPost(apiKeyCheck, { apikey: apiKey }, afterApiKeyCheck);
        }
    })
    const afterApiKeyCheck = (res) => {
        if (!res.data) {
            console.log("バックからの戻り値false");
            store.dispatch({ type: "CLEAR_STATE" });
            history.push("/reserve/login");
        }
    }

    useEffect(() => {
        common.doPost(versionGetApi, {}, afterVerCheck);
        window.scroll({ top: 0, behavior: 'smooth' })
        if (useMediaFlag) {
            setIsMobilePhone(true);
        } else {
            setIsMobilePhone(false);
        }
        
    }, [useMediaFlag]);

    useEffect(() => {

    },[])

    const afterVerCheck = (res) => {
        let flg = common.versionCheck(res.data.version);
        if (flg) {
            history.push("/reserve/login");
            return;
        }
    }

    //予約確認画面に戻る
    const onClickBack = (res) => {
        history.push("/reserve/golf/reservationCheck", {locationFlg: true });
    }

    const timeForm = (timeInfo) => {
        let time = "";
        if (timeInfo.substr(0, 1) === '0') {
            time = timeInfo.substr(1, 1);
        } else {
            time = timeInfo.substr(0, 2);
        }
        time = time + "時";

        if (timeInfo.substr(3, 1) === '0') {
            time = time + timeInfo.substr(4, 1);
        } else {
            time = time + timeInfo.substr(3, 2);
        }
        time = time + "分";
        return time;
    }

    const playerNameConv = (player,playerKana) => {
        if(player !== "未定"){
            if(player && playerKana){
                return "・" + player + "(" + playerKana + ") 様";
            }else if(!player && playerKana){
                return "・" + playerKana + " 様";
            }else if(player && !playerKana){
                return "・" + player + " 様";
            }
        }else{
            return "・未定";
        }
    }
    
    return (
        <>
            <div style={isWideTablet ? styles.breadCrumb2 : styles.breadCrumb}>
                <Link to={"/reserve/top"} style={styles.pan} >HOME</Link>
                <Label label=">" style={styles.breadCrumbArrow} />
                <Link to={{pathname:"/reserve/golf/reservationCheck",state:{locationFlg: true}}} style={styles.pan} >予約確認</Link>
                <Label label=">" style={styles.breadCrumbArrow} />
                <Label label="予約詳細確認" style={styles.pan} />
            </div>
            <div className="userInputInnerWrapper">
                <div style={isWideTablet ? styles.breadCrumb2 : { display: "none" }}></div>
                <div className={isMobilePhone ? "reservationAreaSp" : "reservationDetailArea"}>
                    <div className="reservationComfArea" style={{paddingBottom:"20px"}}>
                        {golfReservationCheck ?
                            <div>
                                <Label label={"ご予約内容"} className={"reservationChkDetailBody"}/>
                                <div>
                                    <Label label={"予約番号"} className={"reservationChkDetailLabelTitle"}/>
                                    <Label label={golfReservationCheck.reservationNo} className={"reservationChkDetailBody leftPadFive"} />
                                </div>
                                <div>
                                    <Label label={"ゴルフ場名"} className={"reservationChkDetailLabelTitle"}/>
                                    <Label label={golfReservationCheck.golfCourseName} className={"reservationChkDetailBody leftPadFive"} />
                                </div>
                                <div>
                                    <Label label={"プレー日"} className={"reservationChkDetailLabelTitle"}/>
                                    <Label label={commonUtil.getStringFromDateJpnMembership(golfReservationCheck.date)} className={"reservationChkDetailBody leftPadFive"} />
                                </div>
                                <Label label={"プレー情報"} className={"reservationChkDetailLabelTitle reservationTitleSpace reservationFontweight"}/>
                                {golfReservationCheck.teeTimeList ? golfReservationCheck.teeTimeList.map((teetime,index) =>(
                                    <div key={index}>
                                        <Label label={index + 1 + "組目"} className={"reservationChkDetailLabelTitle groupLabel"} />
                                        <div>
                                            <Label label={"コース名"} className={"reservationChkDetailLabelTitle leftPadTen"}/>
                                            <Label label={teetime.courseName} className={"reservationChkDetailBody leftPadFifteen"} />
                                        </div>
                                        <div>
                                            <Label label={"スタート時間"} className={"reservationChkDetailLabelTitle leftPadTen"}/>
                                            <Label label={timeForm(teetime.startTime)} className={"reservationChkDetailBody leftPadFifteen"} />
                                        </div>
                                        {/* <div>
                                            <Label label={"プレー合計人数"} className={"reservationChkDetailLabelTitle leftPadTen"}/>
                                            <Label label={teetime.playerList.length + "人"} className={"reservationChkDetailBody leftPadFifteen"} />
                                        </div> */}
                                        <Label label={"プレイヤー"} className={"reservationChkDetailLabelTitle leftPadTen"}/>
                                        {teetime.playerList ? teetime.playerList.map((player,playerIndex) => (
                                            <div key={playerIndex}>
                                                <Label label={playerNameConv(player.playerName,player.playerNameKana)} className={"reservationChkDetailBody leftPadFifteen"} />
                                            </div>
                                        )):null}
                                    </div>
                                )) : null}
                            </div>
                        : null}
                        
                    </div>
                    <div className="reservationChkDtlBtnArea">
                        <Button
                            buttonText="戻る"
                            className="reservationChkDtlBtn"
                            onClick={onClickBack}
                        />
                    </div>
                </div>
            </div>
            <div className="reservationChkFooter">
                <GolfFooterContainer />
            </div>
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        kaiinken:state.kaiinken,
        golfReservationCheck:state.golfReservationCheck
    };
};

const mapToDispatchToProps = (dispatch) => {
    return {
        setKaiinken: (item) => {
            dispatch({ type: "KAIINKEN", payload: {kaiinken:item} })
        },
        setGolfReservationCheck: (item) => {
            dispatch({ type: "GOLF_RESERVATION_CEHCK", payload: {golfReservationCheck:item} })
        }
    };
}

export default connect(mapStateToProps, mapToDispatchToProps)(GolfReservationCheckDetailContainer);


const styles = {
    breadCrumbArrow: {
        marginRight: "5px",
        marginLeft: "5px",
        marginTop: "1px",
        fontSize: "small",
    },
    pan: {
        display: "inline-block",
        padding: "3px",
        color: "white",
        fontSize: "small",
    },
    footer: {
        width: "80%",
        padding: "30px 10% 10px 10%",
        whiteSpace: "nowrap",
        color: "white",
    },
    breadCrumb: {
        display: "flex",
        color: "white",
        paddingLeft: "15%",
        marginBottom: "50px",
        width: "100%",
        paddingTop: "50px",
        boxSizing:"border-box"
    },
    breadCrumb2: {
        visibility: "hidden",
        height: "10px"
    }
}
